module.exports = __webpack_public_path__ + "static/media/ouifm.c34e7b16.png";